import { render, staticRenderFns } from "./EmdTabbar.vue?vue&type=template&id=028eae6d&"
import script from "./EmdTabbar.vue?vue&type=script&lang=js&"
export * from "./EmdTabbar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./EmdTabbar.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

/* hot reload */
if (module.hot) {
  var api = require("/data/vstsagent/user/4158/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('028eae6d')) {
      api.createRecord('028eae6d', component.options)
    } else {
      api.reload('028eae6d', component.options)
    }
    module.hot.accept("./EmdTabbar.vue?vue&type=template&id=028eae6d&", function () {
      api.rerender('028eae6d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/emerald/molecules/EmdTabbar.vue"
export default component.exports